import brasiliaInsuranceCoverage from './brasilia';
import gontijoInsuranceCoverage from './gontijo';
import defaultInsuranceCoverage from './default';

/**
 * Insurance coverage configurations by brand
 */
const insuranceCoverageByBrand = {
  brasilia: brasiliaInsuranceCoverage,
  gontijo: gontijoInsuranceCoverage,
  default: defaultInsuranceCoverage,
};

/**
 * Get insurance coverage configuration for a specific brand
 * @param {string} brand - The brand identifier
 * @param {Array<string>} [coverages=[]] - Array of coverage keys from the API
 * @returns {object} Brand configuration with coverageItems filtered by provided coverages.
 *   Returns empty coverageItems if no coverages provided. Falls back to default brand if brand not found.
 */
export const getInsuranceCoverageByBrand = (brand, coverages = []) => {
  const brandConfig = insuranceCoverageByBrand[brand] || insuranceCoverageByBrand.default;

  // Parse coverages if it comes as a string
  let parsedCoverages = coverages;
  if (typeof coverages === 'string') {
    try {
      parsedCoverages = JSON.parse(coverages);
    } catch (error) {
      console.error('Error parsing coverages JSON:', error);
      parsedCoverages = [];
    }
  }

  // If no coverages are provided from API, return empty coverage items
  if (!parsedCoverages || parsedCoverages.length === 0) {
    return {
      ...brandConfig,
      coverageItems: [],
    };
  }

  // Create a map of coverage keys to coverage data for quick lookup
  const coverageMap = parsedCoverages.reduce((acc, coverage) => {
    acc[coverage.key] = coverage;
    return acc;
  }, {});

  // Filter coverage items to only show those that exist in the provided coverages
  // and add the amount from the API to each item (if available)
  /* eslint-disable function-paren-newline */
  const filteredCoverageItems = brandConfig.coverageItems
    .filter((item) => item.key in coverageMap)
    .map((item) => {
      const coverageData = coverageMap[item.key];
      const result = { ...item };

      // Only add amount if it exists in the coverage data
      if (coverageData.amount !== undefined) {
        result.amount = coverageData.amount;
      }

      return result;
    });
  /* eslint-enable function-paren-newline */

  return {
    ...brandConfig,
    coverageItems: filteredCoverageItems,
  };
};

export default insuranceCoverageByBrand;
